import { Component, Injector, OnInit } from '@angular/core';
import { AppComponentBase } from '@shared/common/app-component-base';
import { appModuleAnimation } from '@shared/animations/routerTransition';
import { Router } from '@angular/router';
import { KnowledgeBankServiceProxy, GetKnowledgeBankForViewDto } from '@shared/service-proxies/service-proxies';
import { finalize } from 'rxjs/operators';

@Component({
    selector: 'app-knowledge-base-public',
    templateUrl: './knowledge-base-public.component.html',
    styleUrls: ['./knowledge-base-public.component.scss'],
    animations: [appModuleAnimation()]
})
export class KnowledgeBasePublicComponent extends AppComponentBase implements OnInit {

    items: GetKnowledgeBankForViewDto[] = [];
    totalCount = 0;
    pageSize = 9;
    currentPage = 0;
    loading = false;
    filterText = '';
    showValidationMessage = false;
    selectedCategory?: number;

    categories = [
        { label: 'اللوائح', value: 1 },
        { label: 'القوانين', value: 2 },
        { label: 'الأدلة الإرشادية', value: 3 },
        { label: 'الاخرى', value: 4 },
    ];

    constructor(
        injector: Injector,
        private _router: Router,
        private _knowledgeBankService: KnowledgeBankServiceProxy
    ) {
        super(injector);
    }

    ngOnInit(): void {
        this.loadItems();
    }

    loadItems(): void {
        this.loading = true;
        const skipCount = this.currentPage * this.pageSize;
        // Using 'creationTime DESC' as default sorting
        this._knowledgeBankService
            .getAllPublished(this.filterText, this.selectedCategory, 'creationTime DESC', skipCount, this.pageSize)
            .pipe(finalize(() => { this.loading = false; }))
            .subscribe((result) => {
                this.items = result.items;
                this.totalCount = result.totalCount;
            });
    }

    onSearch(): void {
        if (this.filterText && this.filterText.trim().length > 0 && this.filterText.trim().length < 3) {
            this.showValidationMessage = true;
            return;
        }
        this.showValidationMessage = false;
        this.currentPage = 0;
        this.loadItems();
    }

    onCategoryChange(): void {
        this.currentPage = 0;
        this.loadItems();
    }

    getCategoryLabel(categoryId: number): string {
        const cat = this.categories.find(c => c.value === categoryId);
        return cat ? cat.label : '';
    }

    get totalPages(): number {
        return Math.ceil(this.totalCount / this.pageSize);
    }

    get pages(): (number | string)[] {
        const total = this.totalPages;
        const current = this.currentPage;
        const pages: (number | string)[] = [];

        if (total <= 7) {
            for (let i = 0; i < total; i++) pages.push(i);
        } else {
            pages.push(0);
            if (current > 2) pages.push('...');
            const start = Math.max(1, current - 1);
            const end = Math.min(total - 2, current + 1);
            for (let i = start; i <= end; i++) pages.push(i);
            if (current < total - 3) pages.push('...');
            pages.push(total - 1);
        }
        return pages;
    }

    goToPage(page: number | string): void {
        if (typeof page !== 'number') return;
        if (page < 0 || page >= this.totalPages) return;
        this.currentPage = page;
        this.loadItems();
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }

    truncateTwoSentences(html: string | undefined, fallbackChars: number = 77): string {
        if (!html) return '';

        const div = document.createElement('div');
        div.innerHTML = html;

        const text = (div.textContent || div.innerText || '')
            .replace(/\s+/g, ' ')
            .trim();

        if (!text) return '';

        const sentences = text.match(/[^.!؟!]+[.!؟!]+|[^.!؟!]+$/g) || [];

        if (sentences.length > 2) {
            return sentences.slice(0, 2).join(' ').trim() + '...';
        }

        if (text.length > fallbackChars) {
            return text.slice(0, fallbackChars).trim() + '...';
        }

        return text;
        }




    prevPage(): void {
        if (this.currentPage > 0) {
            this.currentPage--;
            this.loadItems();
            window.scrollTo({ top: 0, behavior: 'smooth' });
        }
    }

    nextPage(): void {
        if (this.currentPage < this.totalPages - 1) {
            this.currentPage++;
            this.loadItems();
            window.scrollTo({ top: 0, behavior: 'smooth' });
        }
    }

    viewDetails(id: number) {
    this._router.navigate(['/knowledge-base/view', id]);
    }

    stripHtml(html: string): string {
        if (!html) return '';
        return html.replace(/<[^>]*>/g, '');
    }

    truncate(text: string, maxLength: number = 120): string {
        const stripped = this.stripHtml(text);
        if (stripped.length <= maxLength) return stripped;
        return stripped.substring(0, maxLength) + '...';
    }
}
